import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { Icon, IconName } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';

interface SidebarItemProps{
	text: string,
	to?: string,
	exact?: boolean,
	extra?: boolean,
	iconName: IconName,
	badge?: any,
	onClick?: ()=>void,
	goBack?: boolean,
}

var SidebarItem = (props: SidebarItemProps)=>{
	var location = useLocation();
	var navigate = useNavigate();
	
	var active = useMemo(()=>{
		if(!props.to) return false;
		if(props.exact) return location.pathname===props.to;
		if(props.to==='/'){
			return location.pathname===props.to || location.pathname.startsWith('/pagos');
		}
		return location.pathname.startsWith(props.to);
	}, [location.pathname]);

	var Contents = <>
		<Icon name={props.iconName} />
		<div className="text">{props.text}</div>
		{!!props.badge && (
			<div className="badge">{props.badge}</div>
		)}
	</>

	var item_class = classNames('item', {
		extra: props.extra,
		active
	})

	if(props.goBack){
		return <div className={item_class} onClick={()=>navigate(-1)}>
			{Contents}
		</div>
	}

	if(props.to){
		return <Link className={item_class} to={props.to} onClick={props.onClick}>
			{Contents}
		</Link>
	}else{
		return <div className={item_class} onClick={props.onClick}>
			{Contents}
		</div>
	}
}
export default SidebarItem;